import { Injectable, Injector } from '@angular/core'
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { BasicAuthService } from "../../services/basic-auth.service"
import { IConfig, IVersioning } from "../../models/login-response.model"
import { NotifyUserService } from "../../components/notify-user/notify-user.service"

@Injectable()
export class ReaderInterceptor implements HttpInterceptor {
  private readonly authService: BasicAuthService
  private readonly notifyUserService: NotifyUserService

  public constructor(private injector: Injector) {
    this.authService = this.injector.get(BasicAuthService)
    this.notifyUserService = this.injector.get(NotifyUserService)
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>): void => {
        if (event instanceof HttpResponse) {

          if (event.headers.has('X-SPAS-Version')) {
            const versioning: IVersioning = this.authService.getVersioning()

            if (versioning && versioning.frontend?.source && versioning.backend?.source) {
              if (event.headers.get('X-SPAS-Version') !== `${versioning.frontend?.source}.${versioning.backend?.source}`) {
                this.notifyUserService.notify({
                  show: true,
                  type: 'info',
                  message: `The application has been updated in the background, please log out & log in again.`,
                })
              }
            }
          }

          if (event.headers.has('X-SPAS-Cookie-Config')) {
            const cfgValue: IConfig = this.authService.getConfig()

            if (cfgValue && cfgValue.wla && cfgValue.pto_tit) {
              if (event.headers.get('X-SPAS-Cookie-Config') !== `${cfgValue.wla}.${cfgValue.pto_tit.def}.${cfgValue.pto_tit.max}`) {
                const el: string[] = event.headers.get('X-SPAS-Cookie-Config').split('.')
                if (el.length === 3) {
                  this.authService.refreshConfig({
                    wla: parseInt(el[0]),
                    pto_tit: {def: parseInt(el[1]), max: parseInt(el[2])}
                  })
                }
              }
            }
          }
        }
      })
    )
  }
}
